// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__2kQ0d","content":"style__content__SvkVE"};